<template>
  <figure class="image" v-if="image">
    <img :src="`${api_url}${image.url}`"
         :alt="image.alternativeText"
         :title="image.caption"/>
  </figure>
</template>

<script>
export default {
  name: 'vImage',
  data: function() {
    return {
      api_url: process.env.VUE_APP_STRAPI_API_URL
    };
  },
  props: {
    image: {
      type: Object,
    },
  },
};
</script>
